import { useCallback, useEffect, useState } from "react";
import { api } from "../../api.js";
import {
  EmptyState, LoadingRows, Notice, Table, TableCell, TableHead, TableHeader, TableRow,
} from "../../components/ui.jsx";
import PaginationControls from "./PaginationControls.jsx";
import { formatDate } from "./utils.js";

const PAGE_SIZE = 25;

export default function AuditTab() {
  const [offset, setOffset] = useState(0);
  const [state, setState] = useState({ loading: true, audit: [], pagination: null, error: "" });

  const load = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: "" }));
    try {
      const data = await api.platformCatalogAudit({ limit: PAGE_SIZE, offset });
      setState({ loading: false, audit: data.audit, pagination: data.pagination, error: "" });
    } catch (error) {
      setState((current) => ({ ...current, loading: false, error: error.message }));
    }
  }, [offset]);

  useEffect(() => { load(); }, [load]);

  if (state.error) return <Notice>{state.error}</Notice>;
  if (state.loading) return <LoadingRows count={5} />;
  if (!state.audit.length) return <EmptyState title="No platform changes" description="Super Admin changes to the global catalog schema will be recorded here." />;
  return (
    <div className="grid gap-4">
      <Table>
        <TableHead><TableHeader>Action</TableHeader><TableHeader>Administrator</TableHeader><TableHeader>Entity</TableHeader><TableHeader>Details</TableHeader><TableHeader>Time</TableHeader></TableHead>
        <tbody>{state.audit.map((entry) => (
          <TableRow key={entry.id}>
            <TableCell className="font-semibold">{entry.action}</TableCell>
            <TableCell>{entry.actor_name || "Unknown"}</TableCell>
            <TableCell>{entry.entity_type}</TableCell>
            <TableCell className="max-w-[360px] truncate font-mono text-[11px] text-muted-foreground">{JSON.stringify(entry.details)}</TableCell>
            <TableCell className="whitespace-nowrap text-muted-foreground">{formatDate(entry.created_at)}</TableCell>
          </TableRow>
        ))}</tbody>
      </Table>
      <PaginationControls pagination={state.pagination} onChange={setOffset} />
    </div>
  );
}
